import { LicenseManager } from 'ag-grid-enterprise';
import ReactDOM from 'react-dom';
import { xpsPerformance } from '@northerntrust-internal/uxp-analytics';
import App from './App';
import { checkAccessibility } from './utils/checkAccessibility';
import { getDataGridLicenseKey } from './utils/helper';
import './index.css';



export async function initializeApp (): Promise<void> {
  await checkAccessibility();
  xpsPerformance.startPageLoad({
    debug: process.env.NODE_ENV === 'development',
    gaId: '',
    trackCustomEvent: true,
    trackPageLoad: true,
    trackReact: true,
  });
  LicenseManager.setLicenseKey(getDataGridLicenseKey());
}

async function renderApp () {
  await initializeApp();
  // This is breaking calendar dropdown as height calculation is not working correctly. Need to check.
  // const root = createRoot(document.getElementById('app')!);
  // root.render(
  //   <App />
  // );
  ReactDOM.render(<App />, document.getElementById('app'));
}

await renderApp();
